<template>
  <div class="ma-0 pa-0">
    <v-card
      v-if="prop && isCard"
      :height="hasSeeMoreOption ? '120' : '100'"
      @click="
        openDose({
          dose: prop,
          index: index,
          isDrugsManagement: isDrugsManagement,
        })
      "
      class="ma-0 pa-0 mx-2 dose-card"
    >
      <v-row class="ma-0 pa-0">
        <v-col align="center" cols="12">
          <div
            cols="2"
            class="ma-0 pa-0"
            v-for="(animal, index) in prop.animals"
            :key="animals.getAnimalDescription(animal)"
            v-bind:class="
              index == 0 ? 'dose-first-animal' : 'dose-second-animal'
            "
          >
            <v-img
              max-width="30px"
              :src="animals.getAnimalIcon(animal)"
            ></v-img>
            <p class="product-animal-name ma-0 pa-0 mb-3">
              {{ animals.getAnimalDescription(animal) }}
            </p>
          </div>
          <p class="dose-title pa-0 ma-0">{{ prop.title }}</p>
          <p
            class="vetalfa-card-title pa-0 ma-0 mt-2"
            v-bind:class="hasSeeMoreOption ? 'dose-max-width' : ''"
          >
            {{ prop.dose }}
            <span class="dose-measurement" v-if="!hasSeeMoreOption">{{
              prop.measurement
            }}</span>
          </p>
          <p class="dose-description ma-0 pa-0" v-if="!hasSeeMoreOption">
            {{ prop.description }}
          </p>
          <v-chip
            x-small
            class="ma-0 pa-0 px-2 primary--text"
            v-if="!!prop.options"
            color="rgb(0, 114, 138, 0.14)"
          >
            {{ prop.options }}
          </v-chip>
          <div class="dose-go-icon">
            <v-icon size="15" color="#004662">{{ mdiChevronRight }}</v-icon>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      class="ma-0 pa-0 mt-2 dose-card-flat"
      elevation="0"
      v-else-if="prop"
    >
      <v-row v-if="!$route.query.referenced" class="ma-0 pa-0">
        <p class="dose-title pa-0 ml-2 ma-0">{{ prop.title }}</p>
      </v-row>
      <v-row @click="openDrug()" v-else class="ma-0 pa-0">
        <p
          class="
            dose-title
            pa-0
            ml-2
            ma-0
            primary--text
            text-decoration-underline
            vetalfa-pointer
          "
        >
          {{ _getLabel("SEE_DRUG") }}
        </p>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col align="center" cols="12" class="dose-card-flat-content">
          <p
            class="dose pa-0 ma-0 mt-2 pb-2"
            v-bind:class="hasSeeMoreOption ? 'transparent--text' : ''"
          >
            {{ prop.dose }}
            <span class="dose-measurement" v-if="!hasSeeMoreOption">{{
              prop.measurement
            }}</span>
          </p>
          <p class="dose-description ma-0 pa-0" v-if="!hasSeeMoreOption">
            {{ prop.description }}
          </p>
          <div
            v-for="(animal, index) in prop.animals"
            :key="animals.getAnimalDescription(animal)"
            v-bind:class="
              index == 0 ? 'dose-flat-first-animal' : 'dose-flat-second-animal'
            "
          >
            <v-img
              max-width="35px"
              :src="animals.getAnimalIcon(animal)"
              class
            ></v-img>
            <p class="dose-animal-name ma-0 pa-0 mb-3">
              {{ animals.getAnimalDescription(animal) }}
            </p>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style>
.dose-card {
  border-radius: 7px;
  background-color: white;
  cursor: pointer;
  height: 90px;
}
.dose-card-flat {
  height: 90px !important;
  width: 100% !important;
}
.dose-card-flat-content {
  position: relative;
}
.dose-card-flat-icon {
  position: absolute;
  bottom: 0px;
  right: 8px;
}
.dose-animal-name {
  height: 10px;
  color: #393a3a;
  font-size: 8px;
  letter-spacing: 0;
  line-height: 10px;
}
.dose-first-animal {
  position: absolute;
  z-index: 2;
  bottom: 0px;
  left: 8px;
}
.dose-second-animal {
  position: absolute;
  z-index: 2;
  bottom: 0px;
  left: 50px;
}
.dose-flat-first-animal {
  position: absolute;
  z-index: 2;
  bottom: 5px;
  right: 8px;
}
.dose-flat-second-animal {
  position: absolute;
  z-index: 2;
  bottom: 5px;
  right: 50px;
}
.dose-go-icon {
  position: absolute;
  z-index: 2;
  right: 8px;
  top: 40px;
}
.dose-title {
  color: #393a3a;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
  text-align: center;
}
.dose-max-width {
  font-size: 16px;
  max-width: 200px;
}
.dose-measurement {
  color: #393a3a;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
  font-weight: normal;
}
.dose-description {
  color: #393a3a;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
}
.v-card--link:focus:before {
  opacity: 0 !important;
}
</style>

<script>
import animals from "@/constants/animals.enum.js";
import parameters from "@/constants/parameters.js";
import { mdiChevronRight } from "@mdi/js";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "DoseCard",
  props: {
    prop: {
      type: Object,
    },
    index: {
      type: Number,
    },
    isCard: {
      type: Boolean,
      default: false,
    },
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("drugs", ["drug"]),
    hasSeeMoreOption: function () {
      return this.prop.dose.toLowerCase().includes(parameters.CLICK_WORD);
    },
  },
  methods: {
    ...mapActions("drugs", ["openDose", "openCategoryItem"]),
    openDrug() {
      this.openCategoryItem({ id: this.drug.id, category: 1, redirect: true });
    },
  },
  data() {
    return {
      animals,
      mdiChevronRight,
    };
  },
  created() {
    this.prop.animals.sort();
  },
};
</script>